import React from 'react';
import { useRealtorContext } from '../context/RealtorContext';

const DebugInfo: React.FC = () => {
  const context = useRealtorContext();

  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black/80 text-white p-4 rounded-lg text-xs max-w-sm z-50">
      <h4 className="font-bold mb-2">Debug Info</h4>
      <div className="space-y-1">
        <div>Current User: {context.currentUser?.name || 'None'}</div>
        <div>Realtors Count: {context.realtors.length}</div>
        <div>Affiliates Count: {context.affiliates.length}</div>
        <div>Loading: {context.loading ? 'Yes' : 'No'}</div>
        <div>Error: {context.error || 'None'}</div>
        <div>URL: {window.location.pathname}</div>
      </div>
    </div>
  );
};

export default DebugInfo;